import React, { useEffect, useState } from 'react';

interface CelebrationEffectProps {
  duration?: number; // Duration in milliseconds, default 3000ms
  starCount?: number; // Number of stars, default 12
}

const CelebrationEffect: React.FC<CelebrationEffectProps> = ({ 
  duration = 3000, 
  starCount = 12 
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  if (!isVisible) return null;

  // Generate stars with random properties
  const stars = Array.from({ length: starCount }, (_, index) => {
    const angle = (360 / starCount) * index;
    const distance = Math.random() * 150 + 100; // Random distance between 100-250px
    const delay = Math.random() * 500; // Random delay up to 500ms
    const size = Math.random() * 8 + 12; // Random size between 12-20px

    return {
      id: index,
      angle,
      distance,
      delay,
      size,
      x: Math.cos((angle * Math.PI) / 180) * distance,
      y: Math.sin((angle * Math.PI) / 180) * distance,
    };
  });

  return (
    <div className="celebration-effect">
      {stars.map((star) => (
        <div
          key={star.id}
          className="celebration-star"
          style={{
            '--x': `${star.x}px`,
            '--y': `${star.y}px`,
            '--delay': `${star.delay}ms`,
            '--size': `${star.size}px`,
            animationDelay: `${star.delay}ms`,
          } as React.CSSProperties & { [key: string]: string }}
        >
          ⭐
        </div>
      ))}
    </div>
  );
};

export default CelebrationEffect; 